import React from 'react'
import { EditableComponent } from '@adobe/aem-react-editable-components'
import { AuthoringUtils } from '@adobe/aem-spa-page-model-manager'
import {
  ContainerWidths,
  Container as UIFoundationsContainer,
  Zoom as UIFoundationsZoom
} from '@dcxwam/dcx-wam-ui-foundations'
import {
  withErrorBoundary,
  ErrorFallback
} from '../../functional/ErrorBoundary'
import Container from '../Container/Container'
import { NoSsr } from '../../functional/NoSsr/NoSsr'
import ZoomEditConfig from './ZoomEditConfig'
import { ZoomModelProps } from './types'
import { EditableComponentPropsType } from '../../../utils/prop-types'
import withComponentRefresh from '../../../utils/aem/editor/withComponentRefresh'
import { useExtractEditableProps } from '../../../utils/aem/editor/extractEditableProps'

const Zoom: React.FC<EditableComponentPropsType<ZoomModelProps>> =
  withComponentRefresh((props) => {
    if (!props.model) {
      return ZoomEditConfig.emptyLabel
    }
    const { scale, opacity, ...rest } = props.model
    const editableProps = useExtractEditableProps(props, rest)
    const initialScale = Number(scale?.replace(',', '.'))
    const initialOpacity = Number(opacity?.replace(',', '.'))
    const zoomConfig = {
      initialScale: !Number.isNaN(initialScale) ? initialScale : 1,
      initialOpacity: !Number.isNaN(initialOpacity) ? initialOpacity : 1,
      isScalingOverContent: false
    }
    return (
      <NoSsr>
        <EditableComponent {...editableProps}>
          {AuthoringUtils.isInEditor() ? (
            <Container {...editableProps} />
          ) : (
            <UIFoundationsZoom {...zoomConfig}>
              <UIFoundationsContainer width={ContainerWidths.Full}>
                <Container {...editableProps} />
              </UIFoundationsContainer>
            </UIFoundationsZoom>
          )}
        </EditableComponent>
      </NoSsr>
    )
  })

const ZoomWithErrorBoundary = withErrorBoundary(Zoom, {
  componentName: 'Zoom',
  fallback: <ErrorFallback componentName="Zoom" />
})

export default ZoomWithErrorBoundary
